function initials(name = "") {
  const parts = name.trim().split(" ").filter(Boolean);
  if (!parts.length) return "AP";
  return (parts[0][0] + (parts[parts.length - 1][0] || "")).toUpperCase();
}

export default function TeamCard({ member }) {
  return (
    <div data-testid={`team-card-${member.id}`} className="flex flex-col">
      <div className="aspect-[4/5] overflow-hidden rounded-xl bg-navy-surface">
        {member.image_url ? (
          <img src={member.image_url} alt={member.name} loading="lazy" className="h-full w-full object-cover object-top" />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-navy to-navy-light">
            <span className="font-serif text-5xl font-bold text-gold">{initials(member.name)}</span>
          </div>
        )}
      </div>
      <h3 className="mt-5 font-serif text-xl font-semibold text-navy">{member.name}</h3>
      <p className="text-sm font-semibold text-gold">{member.title}</p>
      <p className="mt-3 text-sm leading-relaxed text-slate-600">{member.bio}</p>
    </div>
  );
}
